<template>
    <v-app>
        <Loading v-model:active="isLoading" v-model="fullPage"
       :can-cancel="true"
       :on-cancel="onCancel"
       :is-full-page="fullPage" />

        <div class="show-id-tabs" >

          <NavBar_Patient/>

          <div id="show-id-routing">
            <router-view :id="this.id"
                :server_path="this.server_path"
                :module_server="this.module_server"
                :methods_get_patients="this.methods_get_patients"
                :methods_get_id_data="this.methods_get_id_data"
            >
            </router-view>
          </div>
          {{ this.$store.getters.activeIdData}}

          <div>List Data <br/>
          <!--{{ this.$store.getters.idList }}-->
          </div>

        </div>
    </v-app>
</template>
<script>
import id_requests from "@/methods/id_requests";
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import NavBar_Patient from '@/components/navbars/NavBar_Patient.vue';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: {
      NavBar_Patient,
      Loading
    },
    props: {
        server_path: String,
        module_server: String,
        methods_get_patients: String,
        methods_get_id_data: String
    },
    data : function () {
      return {
        id: '',
        message: '',
        id_data: [],
        surname: '',
        first_name: '',
        birth_date: ''
      }
    },
    beforeCreate: function() {
        this.id = this.$route.query.id
        this.$store.dispatch('setIdData',this.$route.query.id)

        if (this.id in this.$store.getters.idList) {
            // set active ID
            if ("activities" in this.$store.getters.idList[this.id]) {
            if (Object.keys(this.$store.getters.idList[this.id].activities).length == 0) {
                //this.$store.dispatch('setActiveIdData', this.$store.getters.idList[this.id])
                //id_requests.setActiveIdData(this.id)
            } else {
                //alert(Object.keys(this.$store.getters.idList[this.id].activities).length)
                id_requests.setActiveIdData(this.id)
            }
            } else {}
        } else {
            id_requests.getIDFeatureData(this.id)
            this.patients = this.$store.getters.idList
        }



    },
    created: function() {
    },
    mounted: function () {
    },
    methods: {
        getIDData() {

            this.isLoading = true;
                setTimeout(() => {
                this.isLoading = false
            }, 20000)

            var url = this.module_server +this.methods_get_id_data + "?id=" + this.id

            //axios.post(url, requestData)
            axios.get(url)
                .then((response) => {
                    this.res = response;
                    this.message = this.res.data;
                    this.hide=false;

                    var obj_str = JSON.stringify(this.res.data);
                    this.message=obj_str
                    this.id_data = JSON.parse(obj_str);

                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.message = 'error '+this.patients;
                })
        },
        parseIDResponse() {
          if (this.containsKey(this.id_data,"surname")) {
            this.surname = this.id_data[0].surname
          }
          if (this.containsKey(this.id_data,"first_name")) {
            this.surname = this.id_data[0].first_name
          }
          if (this.containsKey(this.id_data,"birth_date")) {
            this.surname = this.id_data[0].birth_date
          }
        },
        containsKey(obj, key ) {
            return Object.keys(obj).includes(key);
        }
    },
    computed: {
        hasName() {
            return this.containsKey(this.someObject, 'name');
        }
    }
}
</script>
<style>
.show-id-personal-data-table {
    width: 300px;
}
.show-id-tabs{

}
.plain_title {
  color:#000000;
  text-decoration: None;
}
</style>
